if (!customElements.get('quick-cart-drawer')) {
  class QuickCartDrawer extends HTMLElement {
    constructor() {
      super();

      this.toggleState = false;
      this.isFetching = false;
      this.boundTriggerHandler = this.handleTriggerClick.bind(this);
    }

    connectedCallback() {
      this.init();

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', () => this.init());
        this.parentElement?.addEventListener('shopify:section:select', () => this.open());
        this.parentElement?.addEventListener('shopify:section:deselect', () => this.close());
      }
    }

    init() {
      this.cacheElements();
      this.bindUI();
      this.initTriggers();
    }

    cacheElements() {
      this.body = document.body;
      this.blocks = this.querySelector('.quick-cart-drawer__blocks');
      this.main = this.querySelector('.quick-cart-drawer__main');
      this.backdrop = this.querySelector('.quick-cart-drawer__backdrop');
      this.closeBtn = this.querySelector('.button--close');
    }

    bindUI() {
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }

      if (this.backdrop) {
        this.backdrop.addEventListener('click', () => this.close());
      }

      if (this.blocks) {
        this.blocks.addEventListener('keydown', (e) => this.handleKeyboard(e));
      }
    }

    handleKeyboard(e) {
      if (e.key === 'Escape') {
        this.close();
      }

      if (e.key !== 'Tab' || !this.toggleState) return;

      const focusables = this.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );

      if (!focusables.length) return;

      const first = focusables[0];
      const last = focusables[focusables.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }

      if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    initTriggers() {
      // CLEAN VERSION: no MutationObserver (BUG FIX)
      document.querySelectorAll('.quick-cart-drawer__trigger').forEach(btn => {
        if (btn._init) return;

        btn.addEventListener('click', this.boundTriggerHandler);
        btn._init = true;
      });
    }

    async handleTriggerClick(event) {
      if (this.isFetching) return;
      this.isFetching = true;

      try {
        const trigger = event.currentTarget.closest('[data-product-url]');
        if (!trigger) return;

        trigger.classList.add('is--loading');

        let fetchPrefix = '';
        if (window.Shopify?.routes?.root?.includes(`/${window.Shopify.locale}/`)) {
          fetchPrefix = `/${window.Shopify.locale}`;
        }

        const url = `${fetchPrefix}${trigger.dataset.productUrl}/?view=quick-cart`;

        const response = await fetch(url);
        const html = await response.text();

        const temp = document.createElement('div');
        temp.innerHTML = html;

        const productNode = temp.querySelector('.quick-cart-product');
        if (!productNode) return;

        this.main.innerHTML = '';
        this.main.appendChild(productNode);

        this.initSwiper();

        setTimeout(() => this.open(), 300);

      } catch (err) {
        console.error('Quick Cart error:', err);
      } finally {
        this.isFetching = false;

        const trigger = event.currentTarget.closest('[data-product-url]');
        trigger?.classList.remove('is--loading');
      }
    }

    initSwiper() {
      if (this.sliderInstance) {
        this.sliderInstance.destroy?.();
      }

      this.sliderInstance = new Swiper('.quick-cart-drawer__media-swiper', {
        slidesPerView: 1.25,
        spaceBetween: 8,
        freeMode: { enabled: true },
        breakpoints: {
          750: { slidesPerView: 2 }
        }
      });
    }

    open() {
      this.toggleState = true;
      this.body.classList.add('overflow-hidden');
      this.classList.add('is--open');

      this.opened();
      this.focusFirstElement();
    }

    close() {
      this.toggleState = false;
      this.body.classList.remove('overflow-hidden');
      this.classList.remove('is--open');

      this.closed();
      this.resetFocus();
    }

    focusFirstElement() {
      const el = this.querySelector('button, [href], input, select, textarea');
      el?.focus();
    }

    resetFocus() {
      document.querySelectorAll('[aria-controls="quick-cart-drawer"]').forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    opened() {
      this.dispatchEvent(new Event('opened', { bubbles: true }));
    }

    closed() {
      this.dispatchEvent(new Event('closed', { bubbles: true }));
    }
  }

  customElements.define('quick-cart-drawer', QuickCartDrawer);
}